<template>
    <tr id="CompanyId" >
        <td colspan="10" v-if="!symbol.monthError && symbol.predictionClose10Day>0" class="TenDaysRow-Column_Data">
            <div class="textGraySmall" v-b-tooltip.hover.html   :title="'Last Full Predicted at '+symbol.predictionDate.split('T')[0]" v-if="symbol.predictionDate">
                10 days prediction: {{symbol.predictionClose10Day|formatPrice}},
                <span v-if="symbol.prediction1Month">{{month1}}: {{ symbol.prediction1Month>0 && symbol.prediction1Month| formatPrice}},</span>
                <span v-if="symbol.prediction2Month">{{month2}}: {{ symbol.prediction2Month>0 && symbol.prediction2Month| formatPrice}},</span>
                <span v-if="symbol.prediction3Month">{{month3}}: {{ symbol.prediction3Month>0 && symbol.prediction3Month| formatPrice}}</span>
                </div>
            <div class="textGraySmall" v-else>
                10 days prediction: {{symbol.predictionClose10Day|formatPrice}},
                <span v-if="symbol.prediction1Month">{{month1}}: {{ symbol.prediction1Month>0 && symbol.prediction1Month| formatPrice}},</span>
                <span v-if="symbol.prediction2Month">{{month2}}: {{ symbol.prediction2Month>0 && symbol.prediction2Month| formatPrice}},</span>
                <span v-if="symbol.prediction3Month">{{month3}}: {{ symbol.prediction3Month>0 && symbol.prediction3Month| formatPrice}}</span>
            </div>
        </td>
        <td colspan="10" v-if="symbol.monthError" class="TenDaysRow-Column_Error">
            <div class="textGraySmall">Error getting predictions</div>
        </td>
    </tr>
</template>
<script>
import {getNextMonth} from '@/utils';

import vue from 'vue'

export default vue.extend({
  props: {
    symbol: { type: Object, required: true },
  },
  data() {
    return {
      month1: getNextMonth(1),
      month2: getNextMonth(2),
      month3: getNextMonth(3),
    };
  },
});
</script>

<style>
    .textGraySmall {
        color: #999;
        font-size: 11px;
    }
   .TenDaysRow-Column_Data {
       text-align: center;
   }
   .TenDaysRow-Column_Error {
       color: red;
   }
</style>

